import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AppConfig from '../../config';
import { t } from '../../lang';
import { appSlice } from '../../store/slices';
import Button from '../Button';
import './PWAInstalHeader.scss';

const { productName: appName } = AppConfig;

const PWAInstalHeader = ({ installPWARef, children }) => {
	const dragRef = useRef(null);
	const startY = useRef(0);

	const dispatch = useDispatch();

	const [isIOS, setIsIOS] = useState(false);
	const [currentY, setCurrentY] = useState(0);
	const [dragging, setDragging] = useState(false);
	const [showHeader, setShowHeader] = useState(
		sessionStorage.getItem('show-PWA-header') === null ? true : sessionStorage.getItem('show-PWA-header') === 'true'
	);

	const isStandalone = useSelector(state => state.app.isPWA);
	const isItTelegram = useSelector(state => state.app.isItTelegram);

	const startDrag = e => {
		startY.current = e.touches ? e.touches[0].clientY : e.clientY;

		setDragging(true);
	};

	const moveDrag = e => {
		if (!dragging) return;

		const y = e.touches ? e.touches[0].clientY : e.clientY;
		const delta = startY.current - y;

		if (delta > 0) {
			setCurrentY(delta);
			dragRef.current.style.transition = 'none';
			dragRef.current.style.top = `${-delta}px`;
		}
	};

	const endDrag = e => {
		setDragging(false);

		if (startY.current - currentY < startY.current / 5) {
			sessionStorage.setItem('show-PWA-header', false);
			setShowHeader(false);
		} else {
			dragRef.current.style.transition = '0.25s';
			dragRef.current.style.top = 0;
		}
	};

	useEffect(() => {
		if (dragging) {
			window.addEventListener('mousemove', moveDrag);
			window.addEventListener('mouseup', endDrag);
			window.addEventListener('touchmove', moveDrag, { passive: false });
			window.addEventListener('touchend', endDrag);
		}

		return () => {
			window.removeEventListener('mousemove', moveDrag);
			window.removeEventListener('mouseup', endDrag);
			window.removeEventListener('touchmove', moveDrag, { passive: false });
			window.removeEventListener('touchend', endDrag);
		};
	}, [dragging]);

	useEffect(() => {
		const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
		setIsIOS(isIOS);

		const mm = window.matchMedia('(display-mode: standalone)');

		const getInstallPWA = e => {
			e.preventDefault();

			installPWARef.current = e;
		};

		const handle = () => {
			const isStandalone = mm.matches || window.navigator.standalone === true;
			dispatch(appSlice.actions.setIsPWA(isStandalone));
		};

		handle();

		mm.addEventListener('change', handle);
		window.addEventListener('beforeinstallprompt', getInstallPWA);

		return () => {
			window.removeEventListener('beforeinstallprompt', getInstallPWA);
			mm.removeEventListener('change', handle);
		};
	}, []);

	const install = async () => {
		const iPWA = installPWARef.current;
		if (!iPWA) return;

		iPWA?.prompt();
	};

	const openIOSModal = () => {
		dispatch(
			appSlice.actions.addModal({
				tag: 'PwaInstallInstruction',
				isOpen: true,
				height: '100%',
				headClass: 'PwaInstallInstruction',
			})
		);
	};

	const showInstallHeader = showHeader && !isStandalone && !isItTelegram;

	// console.log('showHeader', showHeader);
	// console.log('isStandalone', isStandalone);
	// console.log('isItTelegram', isItTelegram);
	// console.log('showInstallHeader', showInstallHeader);

	return (
		<div className='PWAInstalHeader__wrapper'>
			{showInstallHeader && (
				<div className='PWAInstalHeader' ref={dragRef}>
					<div className='PWAInstalHeader__body'>
						<img className='PWAInstalHeader__logo' src={AppConfig.pwaLogo} />
						<div className='PWAInstalHeader__content'>
							<div className='PWAInstalHeader__title'>{appName}</div>
							<div className='PWAInstalHeader__subtitle'>
								{/* {installPWARef.current ? 'Add to Home Screen' : 'Reload page for try install'} */}
								{t('Add to Home Screen')}
							</div>
						</div>
						<Button
							btnSize='small'
							onClick={isIOS ? openIOSModal : install}
							className='PWAInstalHeader__btn'
							disabled={!installPWARef}
						>
							{t('Add')}
						</Button>
					</div>
					<div className='PWAInstalHeader__footer' onTouchStart={startDrag} onMouseDown={startDrag}>
						<div className='PWAInstalHeader__drag-handler'></div>
					</div>
				</div>
			)}
			<div className={classNames('PWAInstalHeader__body-content', { showInstallHeader })}>{children}</div>
		</div>
	);
};

export default PWAInstalHeader;
